import { MultipleFilterModel } from "./MultipleFilterModel";

export class FilterChangedModel {
    public searchString: string;
    public simpleFilters : string[];
    public multipleFilters : MultipleFilterModel[];
}